import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id BE59CDE6-84BE-4489-BAD7-E5B9FE7FE3B2
 * name calendar-start-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-start-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarStartOutlineIcon = createSvgIcon(<><path d="M13 18L9 14V17H4V14H2V22H4V19H9V22L13 18M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V12H5V9H19V19H14.8L12.8 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M5 7V5H19V7H5Z" /></>, 'CalendarStartOutlineIcon');
export default CalendarStartOutlineIcon